// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon--1kfVo","tooltip":"tooltip--mwqC3"};